module.exports = __webpack_public_path__ + "static/media/checkmark-dark.58ad7e07.svg";